module.exports = __webpack_public_path__ + "static/media/gallery12.758b897a.jpg";